import React, { createContext, useState, useEffect } from 'react';

export const AppContextisChecked = createContext();

export const AppProviderisChecked = ({ children }) => {
  const [auth, setAuth] = useState(false)
  const [isChecked, setIsChecked] = useState(() => {
    try {
      const storedValue = localStorage.getItem('isChecked');
      return storedValue !== null ? JSON.parse(storedValue) : false;
    } catch (e) {
      // console.error('Error parsing isChecked from localStorage:', e);
      return true;
    }
  });
  
  useEffect(() => {
    localStorage.setItem('isChecked', JSON.stringify(isChecked));
  }, [isChecked]);

  return (
    <AppContextisChecked.Provider value={{ isChecked, setIsChecked, auth, setAuth }}>
      {children}
    </AppContextisChecked.Provider>
  );
};
